import { Flex } from 'antd'
import Styles from './style.module.scss'

const TITLE = 'Empowering a Sustainable Future with Comprehensive Green Energy Solutions'
const DESCRIPTION = 'Integrated EPC Expertise, Innovative Products, and Flexible Financing'
const data = [
  {
    value: '350 million kWh',
    label: 'Cumulative green power generation',
  },
  {
    value: '30–40 million kWh',
    label: 'Cumulative electricity savings',
  },
  {
    value: '270,000–280,000 metric tons of CO₂',
    label: 'Equivalent emission reduction',
  },
  {
    value: '150+',
    label: 'Projects',
  },
  {
    value: '500+ MWh',
    label: 'Installed Nationwide',
  },
]

export default function Banner() {
  return (
    <div className={Styles.banner}>
      <h1>{TITLE}</h1>
      <div className={Styles.description}>{DESCRIPTION}</div>
      <Flex align='center' justify='space-between' className={Styles.bottom}>
        {data.map((item, index) => (
          <Flex vertical key={index} className={Styles.item}>
            <div className={Styles.value}>{item.value}</div>
            <div className={Styles.label}>{item.label}</div>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}
